document.addEventListener('change', function (event) {
  const swatch = event.target.closest('.card-swatch');

  if (!swatch) return;

  const card = swatch.closest('.card-wrapper.product-card-wrapper');

  if (!card) return;

  const imageUrl = swatch.dataset.imageUrl;
  const imageUrlSmall = swatch.dataset.imageUrlSmall;
  const variantId = swatch.dataset.variantId;

  const cardImage = card.querySelector('.card__media img');

  if (cardImage && imageUrl) {
    cardImage.src = imageUrl;

    cardImage.srcset = `
      ${imageUrlSmall || imageUrl} 360w,
      ${imageUrl} 533w
    `;
  }

  if (variantId) {
    card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);

        url.searchParams.set('variant', variantId);

        link.href = url.pathname + url.search;
      } catch (error) {
        console.error('HeartKingdom swatch link error:', error);
      }
    });

    const variantInput = card.querySelector('.product-variant-id');

    if (variantInput) {
      variantInput.value = variantId;
    }
  }
});